import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { createElement } from "commonAssets/lib/createElement";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import { i18n } from "commonAssets/js/constants";
import formDefault from "../../docs/formDefault.json";

/**
 * Flatten Tagify JSON values to comma-separated strings for display.
 * e.g. [{"value":"Peter"},{"value":"Paul"}] → "Peter, Paul"
 */
function formatTagifyValue(value) {
    if (typeof value === "string") {
        try {
            value = JSON.parse(value);
        } catch {
            const el = createElement("div", { class: "col" });
            el.textContent = value;
            return el;
        }
    }
    if (
        Array.isArray(value) &&
        value.every((item) => item && typeof item === "object" && "value" in item)
    ) {
        const formatted = value.map((item) => item.value).join(", ");
        const el = createElement("div", { class: "col" });
        el.textContent = formatted;
        return el;
    }
    const el = createElement("div", { class: "col" });
    el.textContent = JSON.stringify(value);
    return el;
}

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    confirmation_claim_fields(params) {
        const fields = params.fields;
        const fieldsContainer = createElement("div", {
            class: "mb-3",
            id: "confirmation_claim_fields",
        });
        Object.keys(fields).forEach((key) => {
            const fieldLabel = i18n.getField(key);
            if (
                !params.confirmation.claim_details.excluded_keys.includes(key)
            ) {
                if (fields[key]) {
                    const labelEl = createElement("div", {
                        class: "col fw-bold text-end",
                    });
                    labelEl.textContent = fieldLabel;
                    const row = createElement(
                        "div",
                        { class: "row mb-3 pb-3 border-bottom" },
                        [labelEl, formatTagifyValue(fields[key])]
                    );
                    fieldsContainer.appendChild(row);
                }
            }
        });
        return fieldsContainer;
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}
